// extracted by mini-css-extract-plugin
export default {"ErrorNotificationProviderSignIn":"withAuthenticationErrorHandling_ErrorNotificationProviderSignIn__lYc1I"};